module.exports = __webpack_public_path__ + "static/img/5areaB_5.27327f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/5areaB_5.png
// module id = 1197
// module chunks = 1